import React from "react";
import { Button } from "../Button";
import { Heading } from "../Heading";
import ErrorImage from "../../assets/error.png";
import "./error-message.scss";

export type TErrorMessage = {
    headingText: string;
    descriptionText?: string;
    primaryButtonText?: string;
    primaryButtonOnClick?: () => void;
    secondaryButtonText?: string;
    secondaryButtonOnClick?: () => void;
};

export const ErrorMessage = ({
    headingText = "Something went wrong...",
    descriptionText,
    primaryButtonText,
    primaryButtonOnClick,
    secondaryButtonText,
    secondaryButtonOnClick,
}: TErrorMessage) => {
    return (
        <div className="c-error-message">
            <img
                src={ErrorImage}
                alt="error"
                style={{ width: "100%", maxWidth: 350 }}
                className="c-error-message__img"
            />
            <div className="c-error-message__text">
                <Heading type="h2" className="c-error-message__heading">
                    {headingText}
                </Heading>
                {descriptionText && <p>{descriptionText}</p>}
            </div>
            <div className="c-error-message__actions">
                {secondaryButtonText && secondaryButtonOnClick && (
                    <Button type="secondary" onClick={secondaryButtonOnClick}>
                        {secondaryButtonText}
                    </Button>
                )}
                {primaryButtonText && primaryButtonOnClick && (
                    <Button type="primary" onClick={primaryButtonOnClick}>
                        {primaryButtonText}
                    </Button>
                )}
            </div>
        </div>
    );
};
